// MessageDetailLayoutSelector.jsx
import React from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router';
import PropTypes from 'prop-types';

import useMessageDetailType from '../hook/useMessageDetailType.js';
import Loading from '../component/Loading.jsx';
import UniversalContainer from '../component/UniversalContainer.jsx';
import Redirect from '../container/Redirect.js';

export const MessageDetailLayoutSelector = ({
  isPublished = true,
  meId = null,
  senderId = null,
}) => {
  const layoutType = useMessageDetailType();
  const { messageId } = useParams();

  if (layoutType === 'loading') {
    return (
      <LoadingWrapper>
        <Loading />
      </LoadingWrapper>
    );
  } else {
    const isAuthor = meId && meId === senderId;
    if (!isPublished && !isAuthor) {
      return <Redirect to="/" />;
    }
    switch (layoutType) {
      case 'story': {
        return (
          <UniversalContainer filename="StoryMessage" messageId={messageId} />
        );
      }
      case 'flix': {
        return (
          <UniversalContainer
            filename="FlixDetail"
            messageId={messageId}
            isPublished={isPublished}
          />
        );
      }
      case 'post':
      default: {
        return (
          <UniversalContainer
            filename="PostDetail"
            messageId={messageId}
            isPublished={isPublished}
          />
        );
      }
    }
  }
};

MessageDetailLayoutSelector.propTypes = {
  meId: PropTypes.string,
  senderId: PropTypes.string,
  isPublished: PropTypes.bool,
};

const LoadingWrapper = styled.div`
  padding: 20px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default MessageDetailLayoutSelector;
